import { useStore, State } from 'store';

import getCurrentProjectState from 'store/getCurrentProjectState';

import IUser from 'types/IUser';

const emptyUsers: IUser[] = [];

const selector = (state: State) => getCurrentProjectState(state).usersAsync.data ?? emptyUsers;

export default function useUsers(): IUser[] {
  return useStore(selector);
}
